export enum BigUnit {
  T = 10 ** 12,
  B = 10 ** 9,
  M = 10 ** 6,
  k = 10 ** 3,
}
